/* unplugin-vue-components disabled */import { render } from "./menu-collapse.vue?vue&type=template&id=22788a0a"
import script from "./menu-collapse.vue?vue&type=script&lang=js"
export * from "./menu-collapse.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/basic-layout/menu-side/menu-collapse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22788a0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22788a0a', __exports__)) {
    console.log('reload')
    api.reload('22788a0a', __exports__)
  }
  
  module.hot.accept("./menu-collapse.vue?vue&type=template&id=22788a0a", () => {
    console.log('re-render')
    api.rerender('22788a0a', render)
  })

}


export default __exports__